import * as React from 'react';
import { Button } from './link-button.styles';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}

/**
 * @deprecated
 */
export const LinkButton: React.FC<Props> = (props) => {
  return <Button {...props}>{props.children}</Button>;
};
